import { CmsApiRandomGradProgramsBlockData } from 'modules/cms/api/types/CmsApiRandomGradPrograms';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpRandomGradProgramsBlock } from './CmsAmpRandomGradProgramsBlock';
import { CmsRandomGradProgramsBlock } from './CmsRandomGradProgramsBlock';

export const CmsRandomGradProgramsBlockMapping: CmsBlockMapping<CmsApiRandomGradProgramsBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsRandomGradProgramsBlock,

    AmpComponent: CmsAmpRandomGradProgramsBlock,
  };
